import { Store } from '@website/Store';
import { useContext } from 'react';

/**
 * Admin Only Feature
 *
 * Only displays if the user is an admin, and wraps the content in a bootstrap
 * alert with "Admin" in the top right corner.
 */
export function AdminFeatureInline({
  children,
}: {
  children: React.ReactNode;
}) {
  // Hide if the user is not an admin
  const { state } = useContext(Store);
  const isAdmin = state.user?.roles.includes('admin');
  if (!isAdmin) {
    return null;
  }

  return <>{children}</>;
}
